
  export default {
    props: {
      badgeText: { type: String,
                   default: 'Bonkers Money Limited, trading as bonkers.ie, is regulated by the Central Bank of Ireland.' }
    },
    data () {
      return {
        formDisabled: false
      };
    },
    computed: {
      coverType () {
        return this.$store.getters['products/getCoverType'];
      }
    }
  };
